import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import TextEditorLinkForm from '../../components/text-editor-link-form';
import { closeModal } from '../../actions/close-modal';

const TextEditEditorLinkModal = ({ insertTextEditorLink, closeModal }) =>
  <Modal backdrop={true} onClose={closeModal}>
    <TextEditorLinkForm onSubmit={insertTextEditorLink} onCancel={closeModal}/>
  </Modal>;

TextEditEditorLinkModal.propTypes = {
  insertTextEditorLink: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, { identifier }) =>
  bindActionCreators(
    {
      insertTextEditorLink: data =>
        closeModal({
          ...data,
          identifier,
        }),
      closeModal,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(TextEditEditorLinkModal);



// WEBPACK FOOTER //
// ./app/containers/text-editor-link-modal/text-editor-link-modal.js